<template>
  <section class="board__members">
    <div v-show="BoardMembersList.length != 0" class="container-fluid">
      <div class="row">
        <div
          class="col-lg-4 col-md-4 col-12"
          v-for="(item, index) in BoardMembersList"
          :key="index"
        >
          <div class="member__card">
            <div class="card__img">
              <div class="card__img-inner">
                <img :src="item.Image" alt="member" @error="setDefaultImg"/>
              </div>
            </div>
            <div class="card__body">
              <h3>{{ item.SubTitle }}</h3>
              <p>{{ item.Title }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="generic-error-message" v-show="BoardMembersList.length == 0">
      <p class="message-text"><span>{{Sorry}}</span> {{NoDataFound}}</p>
    </div>
    <div class="generic-loader" v-show="isLoading">
      <img src="../../../src/assets/spinner.svg" alt="EDA Spinner" />
    </div>
  </section>
</template>

<script>
import img from '../../../src/assets/default.png'
export default {
  name: "board-members",
  props: {
    Sorry: {
      type: String,
    },
    NoDataFound: {
      type: String,
    },
    BoardMembersList: {
      type: Array
    }

  },
  methods:{
    setDefaultImg(e){
      e.target.src = img
    }

  },
  mounted(){
  },
  data() {
    return {
      isLoading: false,
      data: [
        {
          id: 1,
          url:
            "https://i.picsum.photos/id/1035/500/500.jpg?hmac=VgIFigWEM4x04jktFvmZVXDqJVVq6XHYyTtPX9C8PtQ",
          name: "أ.د/ تامر محمد عصام",
          title: "رئيس مجلس ادارة الشركة",
        },
        {
          id: 2,
          url:
            "https://i.picsum.photos/id/1035/500/500.jpg?hmac=VgIFigWEM4x04jktFvmZVXDqJVVq6XHYyTtPX9C8PtQ",
          name: "ا.د/ ايمن سعد نصر الدين",
          title: "رئيس مجلس ادارة الشركة",
        },
        {
          id: 3,
          url:
            "https://i.picsum.photos/id/1035/500/500.jpg?hmac=VgIFigWEM4x04jktFvmZVXDqJVVq6XHYyTtPX9C8PtQ",
          name: "ا.د/ ايمن سعد نصر الدين",
          title: "رئيس مجلس ادارة الشركة",
        },
        {
          id: 4,
          url:
            "https://i.picsum.photos/id/1035/500/500.jpg?hmac=VgIFigWEM4x04jktFvmZVXDqJVVq6XHYyTtPX9C8PtQ",
          name: "أ.د/ تامر محمد عصام",
          title: "رئيس مجلس ادارة الشركة",
        },
        {
          id: 5,
          url:
            "https://i.picsum.photos/id/1035/500/500.jpg?hmac=VgIFigWEM4x04jktFvmZVXDqJVVq6XHYyTtPX9C8PtQ",
          name: "ا.د/ ايمن سعد نصر الدين",
          title: "رئيس مجلس ادارة الشركة",
        },
        {
          id: 6,
          url:
            "https://i.picsum.photos/id/1035/500/500.jpg?hmac=VgIFigWEM4x04jktFvmZVXDqJVVq6XHYyTtPX9C8PtQ",
          name: "أ.د/ تامر محمد عصام",
          title: "رئيس مجلس ادارة الشركة",
        },
        {
          id: 7,
          url:
            "https://i.picsum.photos/id/1035/500/500.jpg?hmac=VgIFigWEM4x04jktFvmZVXDqJVVq6XHYyTtPX9C8PtQ",
          name: "ا.د/ ايمن سعد نصر الدين",
          title: "رئيس مجلس ادارة الشركة",
        },
        {
          id: 8,
          url:
            "https://i.picsum.photos/id/1035/500/500.jpg?hmac=VgIFigWEM4x04jktFvmZVXDqJVVq6XHYyTtPX9C8PtQ",
          name: "ا.د/ ايمن سعد نصر الدين",
          title: "رئيس مجلس ادارة الشركة",
        },
        {
          id: 9,
          url:
            "https://i.picsum.photos/id/1035/500/500.jpg?hmac=VgIFigWEM4x04jktFvmZVXDqJVVq6XHYyTtPX9C8PtQ",
          name: "ا.د/ ايمن سعد نصر الدين",
          title: "رئيس مجلس ادارة الشركة",
        },
        {
          id: 10,
          url:
            "https://i.picsum.photos/id/1035/500/500.jpg?hmac=VgIFigWEM4x04jktFvmZVXDqJVVq6XHYyTtPX9C8PtQ",
          name: "ا.د/ ايمن سعد نصر الدين",
          title: "رئيس مجلس ادارة الشركة",
        },
      ],
    };
  },
};
</script>
